import { render, staticRenderFns } from "./BlockedInfoView.vue?vue&type=template&id=352fb8a0&scoped=true&"
import script from "./BlockedInfoView.vue?vue&type=script&lang=js&"
export * from "./BlockedInfoView.vue?vue&type=script&lang=js&"
import style0 from "./BlockedInfoView.vue?vue&type=style&index=0&id=352fb8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352fb8a0",
  null
  
)

component.options.__file = "BlockedInfoView.vue"
export default component.exports